import React from 'react';
import { 
  BarChart3, 
  Target, 
  TrendingUp,
  Brain,
  LineChart,
  Users,
  Building2,
  ArrowRight
} from 'lucide-react';

const ServiciosPage = () => {
  const servicios = [
    {
      icon: <BarChart3 className="h-12 w-12 text-[#4A90E2]" />,
      title: "Evaluación Estratégica de Datos",
      description: "Analizamos tu infraestructura actual de datos y desarrollamos un plan estratégico alineado con tus objetivos de negocio."
    },
    {
      icon: <Target className="h-12 w-12 text-[#4A90E2]" />,
      title: "Alineación de Datos con Objetivos de Negocio",
      description: "Conectamos tus iniciativas de datos directamente con KPIs de negocio para asegurar un ROI tangible."
    },
    {
      icon: <TrendingUp className="h-12 w-12 text-[#4A90E2]" />,
      title: "Implementación Escalable",
      description: "Diseñamos e implementamos soluciones de datos que crecen con tu negocio, evitando retrabajos costosos."
    },
    {
      icon: <Brain className="h-12 w-12 text-[#4A90E2]" />,
      title: "Inteligencia Artificial Aplicada",
      description: "Implementamos soluciones de IA que resuelven problemas específicos de negocio con resultados medibles."
    },
    {
      icon: <LineChart className="h-12 w-12 text-[#4A90E2]" />,
      title: "Visualización y Dashboards",
      description: "Creamos visualizaciones que transforman datos complejos en insights accionables para la toma de decisiones."
    },
    {
      icon: <Users className="h-12 w-12 text-[#4A90E2]" />,
      title: "Diseño de Equipos de Datos",
      description: "Asesoramos en la estructura, roles y capacidades necesarias para construir equipos de datos efectivos."
    }
  ];

  return (
    <>
      {/* Header */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#1A365D] to-[#2A4A7F] text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Nuestros Servicios</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Soluciones de datos diseñadas para generar valor de negocio real y medible para empresas mexicanas
          </p>
        </div>
      </section>

      {/* Servicios Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicios.map((servicio, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all border border-gray-100">
                <div className="mb-6">{servicio.icon}</div>
                <h3 className="text-xl font-bold text-[#1A365D] mb-3">{servicio.title}</h3>
                <p className="text-gray-600 mb-6">{servicio.description}</p>
                <a href="#" className="text-[#4A90E2] font-semibold flex items-center">
                  Conocer más <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Metodología */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-[#1A365D] mb-12">Nuestra Metodología</h2>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-md relative">
              <div className="absolute -top-4 -left-4 bg-[#1A365D] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold">1</div>
              <h3 className="text-xl font-bold text-[#1A365D] mb-3 mt-4">Diagnóstico</h3>
              <p className="text-gray-600">Evaluamos tu situación actual, identificamos oportunidades y definimos objetivos claros.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md relative">
              <div className="absolute -top-4 -left-4 bg-[#1A365D] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold">2</div>
              <h3 className="text-xl font-bold text-[#1A365D] mb-3 mt-4">Estrategia</h3>
              <p className="text-gray-600">Diseñamos un plan de acción alineado con tus objetivos de negocio y KPIs específicos.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md relative">
              <div className="absolute -top-4 -left-4 bg-[#1A365D] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold">3</div>
              <h3 className="text-xl font-bold text-[#1A365D] mb-3 mt-4">Implementación</h3>
              <p className="text-gray-600">Ejecutamos la estrategia con un enfoque ágil, priorizando resultados rápidos y valor tangible.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md relative">
              <div className="absolute -top-4 -left-4 bg-[#1A365D] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold">4</div>
              <h3 className="text-xl font-bold text-[#1A365D] mb-3 mt-4">Medición</h3>
              <p className="text-gray-600">Evaluamos resultados, optimizamos procesos y escalamos soluciones exitosas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#1A365D] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            ¿Listo para transformar tus datos en resultados?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Agenda una sesión de diagnóstico gratuita y descubre cómo podemos ayudarte a alcanzar tus objetivos de negocio.
          </p>
          <a 
            href="https://calendly.com/your-calendly-link"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#27AE60] px-8 py-4 rounded-md hover:bg-[#219653] transition-colors inline-flex items-center justify-center"
          >
            Agendar diagnóstico gratuito
            <ArrowRight className="ml-2 h-5 w-5" />
          </a>
        </div>
      </section>
    </>
  );
};

export default ServiciosPage;